import IKBallConstraint from './IKBallConstraint';

class IKRigidConstraint extends IKBallConstraint {
    constructor() {
        super(0);
    }
}

export default IKRigidConstraint;
